import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";
import { PluggableList } from "react-markdown/lib";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { useTranslation } from "react-i18next";
import { Seo } from "src/components/seo";
import { useCookieConsent } from "src/contexts/cookie-consent-context";
import { usePageView } from "src/hooks/use-page-view";
import { markdownComponents } from "../dashboard/helpers/markdownlhelpers";
import { cookiePolicy } from "./cookie-policy";

const CookiePolicyPage = () => {
  const { t } = useTranslation();
  const { openBanner } = useCookieConsent();

  usePageView();

  return (
    <>
      <Seo title="Cookie Policy" />
      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
          flexGrow: 1,
          py: 15,
        }}
      >
        <Container maxWidth="md">
          <Stack spacing={3}>
            <Box textAlign="center">
              <Typography variant="h3">
                {t("cookiePolicy", "Cookie Policy")}
              </Typography>
            </Box>

            <Typography color="text.primary" variant="body1">
              <Markdown
                children={cookiePolicy}
                components={markdownComponents}
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw] as PluggableList}
              />
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button variant="outlined" color="inherit" onClick={openBanner}>
                {t("resetCsookieSettings", "Reset cookie settings")}
              </Button>
            </Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default CookiePolicyPage;
